import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getAssessmentResponse() {
  const data = await axiosInstance({
    url: "/assessmentResponse",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function getMyAssessmentResponse() {
  const data = await axiosInstance({
    url: "/assessmentResponse/me",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: "/assessmentResponse",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: `/assessmentResponse/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const fastTrackAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: `/assessmentResponse/fastTrack/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteAssessmentResponse = async (formData: any) => {
  const data = await axiosInstance({
    url: `/assessmentResponse/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useAssessmentResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.assessmentResponse],
    queryFn: () => getAssessmentResponse(),
  });
  return data;
}

export function useMyAssessmentResponse() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.userAssessmentResponse],
    queryFn: () => getMyAssessmentResponse(),
  });
  return data;
}

export function useCreateAssessmentResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.userAssessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateAssessmentResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.userAssessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useFastTrackResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => fastTrackAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.assessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteAssessmentResponse() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteAssessmentResponse(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.assessmentResponse]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
